import { useTranslation } from '@blocs.i18n';

const variableKeys = ['1', '2', '3', '4', '5', '6'];

export const useTileSchemeText = (isUnderscoreKey = false): Record<string, string> => {
  const { t } = useTranslation();

  const dynamicValues = variableKeys.map((k) => (isUnderscoreKey ? { [`_${k}`]: k } : { [k]: k }));

  const combinedDynamicValues = Object.assign({}, ...dynamicValues);

  return {
    ...combinedDynamicValues,
    CB: t('common:label.cb.uppercase'),
  };
};
